import React from 'react';
import cx from 'classnames';
import styles from './SwitchCheckbox.m.sass';
export var SwitchCheckbox = function SwitchCheckbox(_ref) {
  var className = _ref.className,
    danger = _ref.danger,
    success = _ref.success,
    onChange = _ref.onChange,
    _ref$trueLabel = _ref.trueLabel,
    trueLabel = _ref$trueLabel === void 0 ? 'On' : _ref$trueLabel,
    _ref$falseLabel = _ref.falseLabel,
    falseLabel = _ref$falseLabel === void 0 ? 'Off' : _ref$falseLabel,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? false : _ref$value,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  value = !!value;
  return /*#__PURE__*/React.createElement("div", {
    role: "checkbox",
    className: cx(styles.root, className, danger && styles.danger, success && styles.success, value && styles.checked, disabled && styles.disabled),
    "aria-checked": value ? 'true' : 'false',
    "aria-disabled": disabled ? 'true' : 'false',
    onClick: function onClick() {
      return !disabled && onChange(!value);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.text
  }, value ? trueLabel : falseLabel), /*#__PURE__*/React.createElement("div", {
    className: styles.toggler
  }));
};
//# sourceMappingURL=index.js.map
